export function formatCurrency(value) {
    let tempValue = value.replace(new RegExp(',', 'g'), ''),
        options = {};

    if (isNaN(tempValue)) {
        return value.replace(/[^\d,]/g, '');
    }

    let formatter = new Intl.NumberFormat('en-US', options);

    return formatter.format(tempValue);
}

export default {
    methods: {
        formatCurrency,
    },
};
